import axios from 'axios';

const baseURL = process.env.REACT_APP_SERVER_URL;

const axiosInstance = axios.create({
  baseURL,
  timeout: 10000,
});

// TODO: Implement axios default headers when APIs support authorization

export default axiosInstance;
